import { EnhancedScopeDataWithBranchName } from '../../scopeData/enhanceScopeData';
import { Graphics } from '../../scopeData/types';
import {
  ENTITY_ID_ATTRIBUTE_KEY,
  EntityName,
  FlexWrapper,
  IconContainer,
} from '../../DiffMergeTable/EntityRepresentation/atoms';
import { APIEntityType, ArdoqId } from '@ardoq/api-types';
import { withComponentModelPopover } from '../../DiffMergeTablePopover/utils';
import { ComponentIconRepresentation } from './ComponentIconRepresentation';
import { EnhancedScopeData } from '@ardoq/data-model';
import { isEnhancedScopeDataWithBranchName } from './utils';

const ComponentTypeRepresentation = ({
  entityId,
  parentEntityId,
  enhancedScopeData,
  graphics,
  isCommaSeparated,
  hasLabelEllipsis,
  hideDefaultPopover,
}: {
  entityId: ArdoqId;
  parentEntityId: ArdoqId;
  enhancedScopeData: EnhancedScopeDataWithBranchName | EnhancedScopeData;
  graphics: Graphics;
  isCommaSeparated?: boolean;
  hasLabelEllipsis?: boolean;
  hideDefaultPopover?: boolean;
}) => (
  <FlexWrapper {...{ [ENTITY_ID_ATTRIBUTE_KEY]: entityId }}>
    <IconContainer>
      <ComponentIconRepresentation
        entityId={entityId}
        entityType={APIEntityType.COMPONENT_TYPE}
        parentEntityId={parentEntityId}
        enhancedScopeData={enhancedScopeData}
        graphics={graphics}
      />
    </IconContainer>
    <EntityName
      entityType={APIEntityType.COMPONENT_TYPE}
      entityId={entityId}
      parentEntityId={parentEntityId}
      enhancedScopeData={enhancedScopeData}
      isCommaSeparated={isCommaSeparated}
      hasLabelEllipsis={hasLabelEllipsis}
      hideDefaultPopover={hideDefaultPopover}
      popoverAttributes={
        isEnhancedScopeDataWithBranchName(enhancedScopeData)
          ? withComponentModelPopover({
              branch: enhancedScopeData.branchName,
              modelId: parentEntityId,
              highlightedComponentTypeId: entityId,
            })
          : undefined
      }
    />
  </FlexWrapper>
);

export { ComponentTypeRepresentation };
